// extracted by mini-css-extract-plugin
export default {"action_btn":"releaseVNModal_action_btn__Pok0-","modal":"releaseVNModal_modal__-jkKr"};